// TickerInput.js
import React from 'react';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const TickerInput = ({ value, onChange, tickerCount, healthStatus }) => (
  <>
    <div className={styles.rowWrapper}>
      <label className={styles.fieldLabel}>
        Tickers ({tickerCount} total)
        {healthStatus?.enabled && (
          <span className={styles.aiHint}>
            &nbsp; AI will analyze these tickers
          </span>
        )}
      </label>
    </div>
    <div className={styles.rowWrapper}>
      <textarea
        id="custom_tickers"
        name="custom_tickers"
        value={value}
        onChange={onChange}
        rows={2}
        className={styles.fullWidthInput}
        placeholder="Enter comma-separated tickers (e.g., AAPL, MSFT, GOOGL)..."
      />
    </div>
  </>
);

TickerInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  tickerCount: PropTypes.number.isRequired,
  healthStatus: PropTypes.shape({
    enabled: PropTypes.bool,
  }),
};

export default TickerInput;